import Summary from './Summary';
import Career from './Career';
import DesignAndArchitecture from './experience/DesignAndArchitecture';
import Coding from './experience/Coding';
import Testing from './experience/Testing';
import OtherExperiences from './experience/Others';
import Contributions from './Contributions';
import Contact from './Contact';

const Sections = { 
  Summary,
  Career,
  DesignAndArchitecture,
  Coding,
  Testing,
  OtherExperiences,
  Contributions,
  Contact,
};

export default Sections;